export const hasAccess = (
  access: string[],
  orgAccess: string[] | undefined,
) => {
  if (access) {
    return access.some((item) => orgAccess?.includes(item));
  }
  return true;
};
